
import { IContainer, injectContainer } from './container';


export interface IStateUserSession {
    id: number;

    sessionName: string;
    grouping: string;
    languageId: number;
    tourId: number;

    setCurrent: () => void;
}

export interface IStateUserSessionManager {
    get: (user: string) => Promise<IStateUserSession>;
    save: (user: IStateUserSession) => Promise<void>;
    remove: (user: IStateUserSession) => Promise<void>;
    current: () => Promise<IStateUserSession|null>;
    new: () => IStateUserSession;
}

const TYPES = {
    IStateUserManager: Symbol.for("IStateUserManager"),
}

export function injectUserSession(container: IContainer = injectContainer()): IStateUserSessionManager {
    return container.get<IStateUserSessionManager>(TYPES.IStateUserManager);
}

export function bindUserSession(val: IStateUserSessionManager, container: IContainer = injectContainer()) {
    return container.bind<IStateUserSessionManager>(TYPES.IStateUserManager, val);
}
